"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommonEvmUtilsConfigSetup = void 0;
var CommonEvmUtilsConfig_1 = require("./CommonEvmUtilsConfig");
var CommonEvmUtilsConfigSetup = /** @class */ (function () {
    function CommonEvmUtilsConfigSetup() {
    }
    CommonEvmUtilsConfigSetup.register = function (config) {
        config.registerKey(CommonEvmUtilsConfig_1.CommonEvmUtilsConfig.formatEvmAddress);
        config.registerKey(CommonEvmUtilsConfig_1.CommonEvmUtilsConfig.formatEvmChainId);
    };
    return CommonEvmUtilsConfigSetup;
}());
exports.CommonEvmUtilsConfigSetup = CommonEvmUtilsConfigSetup;
//# sourceMappingURL=CommonEvmUtilsConfigSetup.js.map